export default __webpack_public_path__ + "static/media/note_stream_1.27e740af.gif";